import enumeraciones from "@/../static/js/enumeraciones";
import comun from "@/../static/js/comun";
import api from "@/../static/js/api";
import router from "@/../src/router/index";
import axios from "axios";

let state = {
  SIFA_Catalogos_003TiposDeActoReclamado: [],
  SIFA_Catalogos_005TiposDeCalificacion: [],
  SIFA_Catalogos_004TiposDeEstadoDeAdmision: [],
  SIFA_Catalogos_011Adscripciones: []
};

let getters = {
  Get_SIFA_Catalogos_003TipoDeActoReclamado: state => {
    return state.SIFA_Catalogos_003TiposDeActoReclamado;
  },
  Get_SIFA_Catalogos_005TipoDeCalificacion: state => {
    return state.SIFA_Catalogos_005TiposDeCalificacion;
  },
  Get_SIFA_Catalogos_004TipoDeEstadoDeAdmision: state => {
    return state.SIFA_Catalogos_004TiposDeEstadoDeAdmision;
  },
  Get_SIFA_Catalogos_011Adscripcion: state => {
    return state.SIFA_Catalogos_011Adscripciones;
  }
};

let mutations = {
  M_SIFA_Catalogos_003TipoDeActoReclamado(state, data) {
    state.SIFA_Catalogos_003TiposDeActoReclamado[data.llave] = data.valor;
  },
  M_SIFA_Catalogos_005TipoDeCalificacion(state, data) {
    state.SIFA_Catalogos_005TiposDeCalificacion[data.llave] = data.valor;
  },
  M_SIFA_Catalogos_004TipoDeEstadoDeAdmision(state, data) {
    state.SIFA_Catalogos_004TiposDeEstadoDeAdmision[data.llave] = data.valor;
  },
  M_SIFA_Catalogos_011Adscripcion(state, data) {
    state.SIFA_Catalogos_011Adscripciones[data.llave] = data.valor;
  }
};

let actions = {
  A_SIFA_Catalogo_Establecer003TipoDeActoReclamado: ({ commit }, data) => {
    commit("M_SIFA_Catalogos_003TipoDeActoReclamado", data);
  },
  A_SIFA_Catalogo_Establecer005TipoDeCalificacion: ({ commit }, data) => {
    commit("M_SIFA_Catalogos_005TipoDeCalificacion", data);
  },
  A_SIFA_Catalogo_Establecer004TipoDeEstadoDeAdmision: ({ commit }, data) => {
    commit("M_SIFA_Catalogos_004TipoDeEstadoDeAdmision", data);
  },
  A_SIFA_Catalogo_Establecer011Adscripcion: ({ commit }, data) => {
    commit("M_SIFA_Catalogos_011Adscripcion", data);
  }
};

const SIFA = {
  Getters: getters,
  State: state,
  Mutations: mutations,
  Actions: actions
};
export default SIFA;



// WEBPACK FOOTER //
// ./src/store/SIFA.js